import { render, staticRenderFns } from "./account_balance.vue?vue&type=template&id=57e4516c&"
import script from "./account_balance.vue?vue&type=script&lang=js&"
export * from "./account_balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports